const MatchNoCard = ({ title }: { title: string }) => {
  return (
    <div className="border rounded bg-gray-500 w-full h-full px-2">
      <p className="text-center font-semibold text-white text-xl">{title}</p>
    </div>
  )
}

export default MatchNoCard
